import { Link } from 'react-router-dom';
import { BsLightningChargeFill, BsFacebook, BsInstagram, BsYoutube, BsLinkedin, BsWhatsapp } from 'react-icons/bs';
import { MdLocationOn, MdPhone, MdEmail, MdAccessTime, MdChevronRight } from 'react-icons/md';
import { IoFlash } from 'react-icons/io5';
import { FaHeart } from 'react-icons/fa';

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-grid">

          {/* Brand */}
          <div>
            <div className="footer-brand-logo">
              <div className="footer-brand-icon"><BsLightningChargeFill /></div>
              <div className="footer-brand-name">SPARK ZONE</div>
            </div>
            <p className="footer-brand-desc">
              Gujarat's most trusted electrical shop since 2012. Powering homes,
              industries and businesses with ISI-certified products and expert service.
            </p>
            <div className="footer-socials">
              {[
                { icon: <BsFacebook />,  href: '#' },
                { icon: <BsInstagram />, href: '#' },
                { icon: <BsYoutube />,   href: '#' },
                { icon: <BsLinkedin />,  href: '#' },
                { icon: <BsWhatsapp />,  href: '#' },
              ].map((s, i) => (
                <a key={i} href={s.href} className="footer-social" aria-label="social">
                  {s.icon}
                </a>
              ))}
            </div>
          </div>

          {/* Quick links */}
          <div>
            <div className="footer-col-title">Quick Links</div>
            <ul className="footer-links">
              {[
                { to: '/',         label: 'Home'       },
                { to: '/products', label: 'Products'   },
                { to: '/services', label: 'Services'   },
                { to: '/why-us',   label: 'Why Us'     },
                { to: '/contact',  label: 'Contact Us' },
              ].map(l => (
                <li key={l.to}>
                  <Link to={l.to} className="footer-link">
                    <MdChevronRight />
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Categories */}
          <div>
            <div className="footer-col-title">Categories</div>
            <ul className="footer-links">
              {['LED Lighting','Wiring & Cables','Switch Gear','Solar & Inverter',
                'Home Automation','Motors & Drives'].map(c => (
                <li key={c}>
                  <span className="footer-link"><MdChevronRight />{c}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <div className="footer-col-title">Contact</div>
            <ul className="footer-links" style={{ gap:'14px' }}>
              <li>
                <span className="footer-link" style={{ alignItems:'flex-start' }}>
                  <MdLocationOn style={{ flexShrink:0, marginTop:2 }} />
                  <span>Ahmedabad, Gujarat</span>
                </span>
              </li>
              <li><a href="tel:+919876543210" className="footer-link"><MdPhone />+91 7698334318</a></li>
              <li><a href="mailto:info@sparkzone.in" className="footer-link"><MdEmail />info@sparkzone.in</a></li>
              <li><span className="footer-link"><MdAccessTime />Mon–Sat: 9AM – 8PM</span></li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="footer-bottom">
          <div className="footer-copy">
            © {year} <span>Spark Zone</span> Electrical. Made with <FaHeart /> in Ahmedabad.
          </div>
          <div className="footer-copy">
            <a href="#" style={{ color:'var(--primary)' }}>Privacy Policy</a>
            <span style={{ margin:'0 10px', opacity:.4 }}>|</span>
            <a href="#" style={{ color:'var(--primary)' }}>Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
}